import {
    GET_MEDIA,
    GET_MEDIA_SUCCESS,
    GET_MEDIA_FAILED,
} from './actionTypes';

export const getMedia = () => {
    return {
        type: GET_MEDIA
    }
}
export const getMediaSuccess = (media) => {
    return {
        type: GET_MEDIA_SUCCESS,
        payload: media
    }
}

export const getMediaFailed= () => {
    return {
        type: GET_MEDIA_FAILED
    }
}
